const NotFound = () => {
    return (
        <div>Page Not Found 404</div>
    )
};

export default NotFound;